import {BaseGateway, CheckoutGateway as StripeCheckoutGateway} from '@paymentplugins/wc-stripe';
import $ from 'jquery';
import {isEmail} from "@wordpress/url";
import ApplePayMixin from './applepay-mixin';

function Gateway(params, elementSelector) {
    this.elementSelector = elementSelector;
    BaseGateway.call(this, params);
    this.message_container = 'li.payment_method_' + this.gateway_id;
    this.banner_container = 'li.banner_payment_method_' + this.gateway_id;
};

Gateway.prototype = Object.assign(Gateway.prototype, BaseGateway.prototype, StripeCheckoutGateway.prototype);

class ApplePayExpressCheckout extends ApplePayMixin(Gateway) {

    constructor(params, elementSelector) {
        super(params, elementSelector);
        this.setupIntent = null;
        this.paymentMethodType = null;
        this.paymentElementComplete = false;
    }

    initialize() {
        this.type = 'applePay';
        this.setupEvents();
        this.createExpressElement();
        this.mountPaymentElement();
    }

    setupEvents() {
        $(document.body).on('updated_checkout', this.onUpdatedCheckout.bind(this));
        window.addEventListener('hashchange', this.onHashChange.bind(this));
    }

    mountPaymentElement() {
        if ($('li.payment_method_' + this.gateway_id).length) {
            super.mountPaymentElement();
        } else {
            if (this.expressCheckoutElement) {
                this.expressCheckoutElement.unmount();
            }
        }
    }

    onReady({availablePaymentMethods}) {
        const {applePay = false} = availablePaymentMethods || {};
        this.isEligible = applePay;
        if (this.isEligible) {
            $(this.elementSelector).show().addClass('active');
            $('.wc-stripe-banner-checkout').addClass('active');
        } else {
            $(this.elementSelector).hide();
        }
    }

    onClickElement(event) {
        super.onClickElement(event);
        $('[name="terms"]').prop('checked', true);
        this.set_payment_method(this.gateway_id);
        this.set_use_new_option(true);
    }

    onUpdatedCheckout(e, data) {
        if (data && data?.fragments?.[this.gateway_id]) {
            this.params = {...this.params, ...data.fragments[this.gateway_id]};
            this.updatePaymentElement();
        }
        this.mountPaymentElement();
    }

    async on_token_received(paymentMethod) {
        $('[name="payment_method"]').val(this.gateway_id);
        this.maybe_set_ship_to_different();
        this.fields.toFormFields({update_shipping_method: false});
        await this.triggerUpdatedCheckout();
        this.payment_token_received = true;
        this.set_nonce(paymentMethod.id);
        $(document.body).triggerHandler('wc_stripe_applepay_payment_method_received', [paymentMethod]);
        this.get_form().trigger('submit');
    }

    getExpressElementOptions() {
        this.expressElementOptions = super.getExpressElementOptions();
        this.expressElementOptions.emailRequired = !isEmail($('#billing_email').val() ?? '');
        this.expressElementOptions.phoneNumberRequired = this.fields.required('billing_phone')
            || this.fields.required('shipping_phone');
        return this.expressElementOptions;
    }

    populate_shipping_fields(address) {
        super.populate_shipping_fields(address);
        $(document.body).one('updated_checkout', () => {
            super.populateDomFields(address);
        });
    }

    populate_billing_fields(address) {
        super.populate_billing_fields(address);
        $(document.body).one('updated_checkout', () => {
            super.populateDomFields(address);
        });
    }
}

new ApplePayExpressCheckout(
    wc_stripe_applepay_checkout_params,
    '.banner_payment_method_stripe_applepay'
);
